import * as React from 'react';
import * as _ from 'lodash';
import * as moment from 'moment';
import { Dispatch, connect } from 'react-redux';
import { IBillingState, BillingActionCreators, IApplicationState, AppActionCreators, INotBilledListResponse, INotBilled } from '@nkr/store/index';
import { ISortBy } from '@nkr/models/index';
import { FormControl, FormGroup, Glyphicon } from 'react-bootstrap';
import BilledManuallyRow from './billed-manually-row';
import { TableWrapper } from '../styles';
import NoData from '../no-data';
import NavDonorCenter from '../nav-donor-center';
import { NavSubWrapper } from '../../styles';

interface IOwnProps {
    centerId: number,
    centerAlias: string
}

interface IStateProps {
    billing: IBillingState
}

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getBilledManuallyList: (centerId: number) => Promise<INotBilledListResponse>
}

type TProps = IStateProps & IDispatchProps & IOwnProps;

interface IState {
    list: INotBilled[],
    dateRange: number,
    sortBy: ISortBy
}

class BilledManually extends React.Component<TProps, IState> {
    readonly state: IState = {
        list: [],
        dateRange: 0,
        sortBy: { property: 'transplantDate', direction: 'asc' }
    }

    componentDidMount = () => {
        this.getData();
    }

    handleDateRangeChange = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        this.setState({
            dateRange: parseInt(e.currentTarget.value)
        });
    }

    handleSort = (property: string) => {
        let sortBy = _.cloneDeep(this.state.sortBy);

        if (sortBy.property == property) {
            if (sortBy.direction == 'asc') {
                sortBy.direction = 'desc'
            } else {
                if (sortBy.direction == 'desc') {
                    sortBy = { property: '', direction: '' };
                }
            }
        } else {
            sortBy = { property, direction: 'asc' };
        }

        this.setState({
            sortBy
        });
    }

    handleStartBilling = (donorId: number) => {
        window.location.href = `/center/${this.props.centerId}/billing/view-edit/${donorId}`;
    }

    getData = () => {
        this.props.showLoading('Getting manually billed invoices, one moment please...').then(() => {
            this.props.getBilledManuallyList(this.props.centerId).then(response => {
                if (response.data.success) {
                    this.setState({
                        list: response.data.results
                    });
                }

                this.props.hideLoading();
            });
        });
    }

    getFilteredRows = () => {
        return this.state.list.filter(x => {
            let dateRange = this.state.dateRange > 0 ? moment(x.transplantDate).isAfter(moment().addDays(-1 * this.state.dateRange)) : true;

            return dateRange;
        });
    }

    getSortedRows = () => {
        let { property, direction } = this.state.sortBy;
        let filteredRows = this.getFilteredRows();
        let sortedRows: INotBilled[] = [];

        if (property != '') {
            sortedRows = _.orderBy(filteredRows, item => {
                switch (property) {
                    case 'transplantDate': return moment(item.transplantDate).format('YYMMDD');
                    case 'swapNumber': return parseInt(item.chainId + '' + item.clusterNumber + '' + item.positionNumber);
                    case 'donorCenter': return item.donor.center.alias;
                    case 'donorAlias': return item.donor.alias;
                    case 'recipientAlias': return item.recipient.alias;
                    case 'recipientCenter': return item.recipient.center.alias;
                }

            }, [direction]);
        } else {
            sortedRows = filteredRows;
        }

        return sortedRows;
    }

    renderHeaderSort = (property: string) => {
        if (this.state.sortBy.property == property) {
            return <Glyphicon glyph={this.state.sortBy.direction == 'asc' ? 'triangle-top' : 'triangle-bottom'} style={{ marginLeft: 5 }} />;
        } else {
            return null;
        }
    }

    render = () => {
        const sortedRows = this.getSortedRows();

        return (
            <>
                <div style={{ marginBottom: 10, padding: '0px 5px 0px 5px' }}>
                    <NavSubWrapper verticalAlign='center' minTabWidth='85' fontSize='12px'>
                        <NavDonorCenter
                            section={'BILLED-MANUALLY'}
                            tabText={''}
                            centerId={this.props.centerId}
                            centerAlias={this.props.centerAlias}
                        />

                        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <FormGroup style={{ marginBottom: 0, marginRight: 20 }}>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <div style={{ marginRight: 5 }}>Filter by Date Range:</div>
                                    <div>
                                        <FormControl
                                            componentClass='select'
                                            value={this.state.dateRange}
                                            onChange={this.handleDateRangeChange}
                                        >
                                            <option value={0}>- Show All -</option>
                                            <option value={90}>Past 90 Days</option>
                                            <option value={180}>Past 180 Days</option>
                                            <option value={365}>Past Year</option>
                                        </FormControl>
                                    </div>
                                </div>
                            </FormGroup>
                        </div>
                    </NavSubWrapper>

                    {sortedRows.length > 0 ?
                        <TableWrapper striped>
                            <thead>
                                <tr>
                                    <th style={{ cursor: 'pointer' }} onClick={() => this.handleSort('transplantDate')}>TXP Date  {this.renderHeaderSort('transplantDate')}</th>
                                    <th style={{ cursor: 'pointer' }} onClick={() => this.handleSort('swapNumber')}>Swap #  {this.renderHeaderSort('swapNumber')}</th>
                                    <th style={{ cursor: 'pointer' }} onClick={() => this.handleSort('donorCenter')}>Donor Center {this.renderHeaderSort('donorCenter')}</th>
                                    <th style={{ cursor: 'pointer' }} onClick={() => this.handleSort('donorAlias')}>Donor Alias {this.renderHeaderSort('donorAlias')}</th>
                                    <th style={{ cursor: 'pointer' }} onClick={() => this.handleSort('recipientCenter')}>Recipient Center {this.renderHeaderSort('recipientCenter')}</th>
                                    <th style={{ cursor: 'pointer' }} onClick={() => this.handleSort('recipientAlias')}>Recipient Alias {this.renderHeaderSort('recipientAlias')}</th>
                                    <th style={{ cursor: 'pointer' }} onClick={() => this.handleSort('claimType')}>Claim Type  {this.renderHeaderSort('claimType')}</th>
                                    <th className='text-center'>Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                {sortedRows.map((item, index) =>
                                    <BilledManuallyRow
                                        key={index}
                                        data={item}
                                        onStartBilling={this.handleStartBilling}
                                    />
                                )}
                            </tbody>
                        </TableWrapper>
                        :
                        <NoData message={'No manually billed invoices...'} />
                    }
                </div>
            </>
        );
    }
}

const mapStateToProps = (appState: IApplicationState, ownProps: IOwnProps): IStateProps => {
    return {
        billing: appState.billing
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => { return dispatch(AppActionCreators.showLoadingAsync(message)); },
        hideLoading: () => { dispatch(AppActionCreators.hideLoading()); },
        getBilledManuallyList: (centerId) => { return dispatch(BillingActionCreators.getBilledManuallyList(centerId)); }
    };
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(BilledManually);